import {IconFolder} from "@tabler/icons-react";
import {Group, Text} from "@mantine/core";
import {useContext, useEffect, useState} from "react";
import QRCodeDetailsContext from "../../../QRCodeDetailsContext";

type FolderSmallBadgeProps = {};

/**
 * @author Kacper Faber
 * @since 0.1.8
 * @param _
 * @constructor
 */
function FolderSmallBadge(_: FolderSmallBadgeProps) {
    const ctx = useContext(QRCodeDetailsContext);

    const [folderName, setFolderName] = useState<string>();

    /**
     * Reload folder name.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const reload = () => {
        setFolderName(ctx.qrCode?.folder?.name);
    };

    useEffect(reload);

    if (!folderName) {
        return null;
    }

    return (
        <Group gap="0.3rem" justify="left" align="center">
            <IconFolder
                size="1.01rem"
                color="rgba(83, 103, 140, 100)"
            />

            <Text
                c="rgba(83, 103, 140, 100)"
                children={folderName}
                size="sm"
            />
        </Group>
    );
}

export default FolderSmallBadge;